<template>
  <view-wrapper>
      <carrosal />
        <div
          class="absolute bottom-0 left-0 right-0 top-auto w-full overflow-hidden pointer-events-none"

        >
          <svg
            class="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              class="text-gray-300 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
  </view-wrapper>
</template>

<script>
import Carrosal from '../components/Carrosal.vue';
import ViewWrapper from '../components/ViewWrapper.vue';

export default {
  name: 'home',
  components: {
    Carrosal,
    ViewWrapper,
  },
};
</script>
